import { useState } from 'react';

import { Link } from 'react-router';

import { AnswerSource } from '@cfa/pathway-fe-shared/xp';
import { Chip } from '@cfa/react-core';

import { useSearchClickFeedback, useSearchDocLink } from '../hooks';

const MAX_VISIBLE = 3;

interface SourcesProps {
  sources: AnswerSource[];
}

/** Sources chip list with overflow collapse. */
const SourceChip: React.FC<{
  source: AnswerSource;
  onClick: () => void;
}> = ({ source, onClick }) => {
  const docLink = useSearchDocLink(source.documentId);

  return (
    <Link
      to={docLink}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
    >
      <Chip className="bg-base-0! hover:bg-base-2! border-brand-navy! text-brand-navy! dark:border-contrast! dark:text-contrast! transition-colors">
        {source.name}
      </Chip>
    </Link>
  );
};

const Sources: React.FC<SourcesProps> = ({ sources }) => {
  const [expanded, setExpanded] = useState(false);
  const sendClickFeedback = useSearchClickFeedback();

  const citedSources = sources.filter(_ => _.cited);
  const visibleSources = expanded
    ? citedSources
    : citedSources.slice(0, MAX_VISIBLE);
  const hiddenCount = citedSources.length - MAX_VISIBLE;

  return (
    <>
      {visibleSources.map(source => (
        <SourceChip
          key={source.name}
          source={source}
          onClick={() => sendClickFeedback(source)}
        />
      ))}
      {!expanded && hiddenCount > 0 && (
        <button onClick={() => setExpanded(true)}>
          <Chip className="bg-base-0! hover:bg-base-2! border-brand-navy! text-brand-navy! dark:border-contrast! dark:text-contrast! cursor-pointer transition-colors">
            +{hiddenCount}
          </Chip>
        </button>
      )}
    </>
  );
};

export default Sources;
